(function () {
  const selector = '.titta-freeship';

  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.settings && theme.settings.moneyFormat) {
        return Shopify.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}

    return '$' + Math.round(cents / 100).toLocaleString('es-CO');
  }

  function updateBars(cart) {
    const bars = document.querySelectorAll(selector);
    if (!bars.length || !cart) return;

    bars.forEach(function (bar) {
      const threshold = parseInt(bar.dataset.threshold || '17400000', 10);
      const total = cart.total_price || 0;
      const remaining = Math.max(0, threshold - total);
      const progress = threshold > 0 ? Math.min(100, Math.round((total * 100) / threshold)) : 0;

      const msg = bar.querySelector('.titta-freeship__msg');
      const fill = bar.querySelector('.titta-freeship__fill');
      const truck = bar.querySelector('.titta-freeship__truck');

      if (msg) {
        if (remaining <= 0) {
          msg.innerHTML = '¡Lograste el envío GRATIS!';
        } else {
          msg.innerHTML = '¡Ya casi! Te faltan ' + formatMoney(remaining) + ' para que tu envío sea GRATIS.';
        }
      }

      if (fill) fill.style.width = progress + '%';
      if (truck) truck.style.left = progress + '%';
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(updateBars)
      .catch(function () {});
  }

  function hookCartChanges() {
    const originalFetch = window.fetch;

    window.fetch = function () {
      const response = originalFetch.apply(this, arguments);

      try {
        const url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0].url;

        if (url && url.includes('/cart/')) {
          response.then(function () {
            setTimeout(fetchCartAndUpdate, 250);
            setTimeout(fetchCartAndUpdate, 700);
          });
        }
      } catch (e) {}

      return response;
    };

    const originalOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        try {
          if (typeof url === 'string' && url.includes('/cart/')) {
            setTimeout(fetchCartAndUpdate, 250);
            setTimeout(fetchCartAndUpdate, 700);
          }
        } catch (e) {}
      });

      return originalOpen.apply(this, arguments);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    hookCartChanges();
    fetchCartAndUpdate();
  });

  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('ajaxProduct:added', fetchCartAndUpdate);
  document.addEventListener('drawer:open', fetchCartAndUpdate);
  document.addEventListener('cart:refresh', fetchCartAndUpdate);

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.js-qty__adjust') ||
      event.target.closest('[data-cart-item-remove]') ||
      event.target.closest('.drawer') ||
      event.target.closest('button[name="add"]')
    ) {
      setTimeout(fetchCartAndUpdate, 400);
      setTimeout(fetchCartAndUpdate, 900);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.closest('.drawer') || event.target.name === 'updates[]') {
      setTimeout(fetchCartAndUpdate, 400);
      setTimeout(fetchCartAndUpdate, 900);
    }
  }, true);
})();